import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PaymentRequestConfigurationConverter} from './api/entity/converter/paymentRequestConfiguration.converter';
import {PaymentRequestConfigurationDataServiceAdapter} from './impl/service/ngrx/paymentRequestConfigurationDataService.adapter';
import {PaymentRequestConfigurationRepository} from './impl/service/ngrx/paymentRequestConfiguration.repository';
import {PaymentRequestConfigurationDataService} from './impl/service/ngrx/paymentRequestConfigurationData.service';

@NgModule({
    providers: [
        PaymentRequestConfigurationConverter,
        PaymentRequestConfigurationDataService,
        PaymentRequestConfigurationRepository,
        PaymentRequestConfigurationDataServiceAdapter,
    ],
    imports: []
})
export class PaymentRequestConfigurationModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: PaymentRequestConfigurationRepository,
                dataService: PaymentRequestConfigurationDataService,
    ) {

        entityDataService.registerServices({
            PaymentRequestConfiguration: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PaymentRequestConfiguration: repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
